<template>
    <div class="box">
        <div class="auction-header">
            <div class="auction-herder-container flex between">
                <div></div>
                <div class="size20 bold ">拍得榜</div>
                <div class="size24" @click="closeAuction">×</div>
            </div>
            
        </div>
        <div class="auction-content">
            <van-empty v-if="list.length == 0" description="数据为空" />
            <van-list v-model:loading="loading" :finished="finished" @load="onLoad">
             <div v-for="item,index in list " :key="index" class="flex between mary10 bold">
               <div class="left">{{ item.nickname }}拍得{{ item.goods_name }}</div>
               <div class="right">{{ item.show_time }}</div>
             </div>
              <template #finished>{{ finishtxt }}</template>
            </van-list>
        </div>
    </div>
</template>

<script setup>
import ajax from "@/utils/request.js";
import { defineEmits, ref } from 'vue';
const emits = defineEmits(['closeJs'])
const closeAuction = () => {
    emits('closeJs')
}
const page = ref(1)
const list = ref([])
const loading = ref(false)
const finished = ref(false)
const finishtxt = ref("")
const init = ()=>{
    loading.value = true
    const data = {
        page : page.value
    }
    ajax.post("products/getauctionlist",data).then(res=>{
        if(res.errcode == 1){
            console.log(res);
            if(res.data.length < 10){
                finishtxt.value = "";
                finished.value = true;
                list.value = list.value.concat(res.data);
                setTimeout(() => {
                finishtxt.value = "没有更多了";
                }, 1000);
            }else{
                finishtxt.value = "";
                list.value = list.value.concat(res.data);
                page.value++;
            }
        }
    })
    .finally(() => {
          loading.value = false;
        })
        .catch(() => {
          finished.value = true;
        });
}
init()

const onLoad =  ()=> {
      init();
    }

</script>

<style lang="scss" scoped>
.box{
    height: 75vh;
    border-top-left-radius: 30px;
    .auction-header{
        position: fixed;
        top: 10vh;
        left: 0;
        width: 100%;
        padding: 10px 15px;
        background-color: #fff;
    }
    .auction-content{
        padding-top: 10vh;

        .left{
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .right{
            width: 20%;
            text-align: right;
        }
    }

}
</style>